import { GA3_TRACKING_ID, GA4_TRACKING_ID } from "../consts";
import * as Sentry from "@sentry/react";
import { User } from "../types";
import { amplitudeSetUser, amplitudeSetUserProperties } from "./amplitude";

export function trackUser(user: User) {
  Sentry.setUser({ username: user.id });
  amplitudeSetUserProperties({ anonymous: !!user.anonymous });

  if (!user.anonymous) {
    amplitudeSetUser(user.id);
  }

  window.gtag("get", GA3_TRACKING_ID, "client_id", (client_id) => {
    window.gtag("set", "user_properties", {
      custom_client_id: client_id,
    });

    if (!user.anonymous) {
      // GA4
      window.gtag("set", "user_properties", {
        custom_client_id: client_id,
        custom_user_id: user.id,
      });
      window.gtag("config", GA4_TRACKING_ID, {
        user_id: user.id,
      });

      // GA3
      window.gtag("config", GA3_TRACKING_ID, {
        user_id: user.id,
      });
      window.gtag("set", "dimension2", user.id);
    } else {
      window.gtag("config", GA3_TRACKING_ID);
    }
    window.gtag("set", "dimension1", client_id);
  });
}
